// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IPad: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 59.5"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M43.4.4H3.6C1.8.4.4 1.8.4 3.6V56c0 1.8 1.4 3.2 3.2 3.2h39.7c1.8 0 3.2-1.4 3.2-3.2V3.6c0-1.8-1.4-3.2-3.1-3.2zm.4 3.2V56c0 .2-.2.4-.4.4H3.6c-.2 0-.4-.2-.4-.4V3.6c0-.2.2-.4.4-.4h39.7c.3 0 .5.1.5.4z"/><path d="M40.2 5.8H6.9c-.6 0-1 .5-1 1v42.3c0 .6.4 1 1 1h33.3c.6 0 1-.4 1-1V6.8c0-.6-.4-1-1-1zm-1.8 2.8v38.8H8.6V8.6h29.8z"/><circle cx="24.4" cy="53.3" r="2"/></svg>;
};

export default React.memo(IPad);
